import { memo, useEffect, useState } from 'react'
import IRPlate from '../plate/IRPlate'
import ArasPlate from '../plate/ArasPlate'

function PlateInput({ isSubmit, inputHandler, inputs, error, setInputs }) {
  const [isAras, setIsAras] = useState(false)

  useEffect(() => {
    if (inputs?.aras_plate) {
      setIsAras(true)
    } else {
      setIsAras(false)
    }
  }, [inputs?.aras_plate])

  const checkAras = () => {
    setIsAras(!isAras)
    setInputs({
      ...inputs,
      aras_plate: '',
      first: '',
      letter: '',
      second: '',
      state: '',
    })
  }
  return (
    <>
      <label htmlFor="color" className={'text-base font-normal mb-3'}>
        <div className="flex items-center justify-between">
          <span className={'dark:text-gray-200'}>پلاک خودرو</span>
          <label className={'cursor-pointer flex items-center dark:text-gray-200'} htmlFor="aras">
            <input
              type="checkbox"
              name={'aras'}
              id={'aras'}
              checked={isAras}
              onChange={checkAras}
              className={'ml-2'}
            />
            ارس پلاک
          </label>
        </div>
        <>
          {isAras ? (
            <>
              <ArasPlate
                isSubmit={isSubmit}
                inputHandler={inputHandler}
                aras_plate={inputs?.aras_plate}
              />
              {error?.aras_plate && <p className={'text-rose-500 my-1'}>{error?.aras_plate}</p>}
            </>
          ) : (
            <>
              <IRPlate
                isSubmit={isSubmit}
                inputHandler={inputHandler}
                first={inputs?.first}
                letter={inputs?.letter}
                second={inputs?.second}
                state={inputs?.state}
              />
              {error?.first && <p className={'text-rose-500 my-1'}>{error?.first}</p>}
              {error?.letter && <p className={'text-rose-500 my-1'}>{error?.letter}</p>}
              {error?.second && <p className={'text-rose-500 my-1'}>{error?.second}</p>}
              {error?.state && <p className={'text-rose-500 my-1'}>{error?.state}</p>}
            </>
          )}
        </>
      </label>
    </>
  )
}

export default memo(PlateInput)
